module.exports = __webpack_public_path__ + "static/img/share_img8.56c93291.png";